import React from "react";
import { IoPlaySharp } from "react-icons/io5";

const BookNowBTN = () => {
  return (
    <div className="occupational-therapy-book-btn">
      Book free consultation now
      <IoPlaySharp
        style={{
          marginTop: 1,
        }}
      />
    </div>
  );
};

export default BookNowBTN;
